<template>
  <div>
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="archive-main">
      <div class="arm-head">
        <img src="../../assets/images/titleimg.png" alt="" /> Hot Keywords In
        <div
          class="arm-head-btn"
          :class="yearindex == 0 ? 'arm-head-btn-act' : ''"
          @click="changeyear(0)"
        >
          2017
        </div>
        <div
          class="arm-head-btn"
          :class="yearindex == 1 ? 'arm-head-btn-act' : ''"
          @click="changeyear(1)"
        >
          2019
        </div>
        <div
          class="arm-head-btn"
          :class="yearindex == 2 ? 'arm-head-btn-act' : ''"
          @click="changeyear(2)"
        >
          2021
        </div>
        <div
          class="arm-head-btn"
          :class="yearindex == 3 ? 'arm-head-btn-act' : ''"
          @click="changeyear(3)"
        >
          2022
        </div>
      </div>
      <div class="arm-body">
        <div class="arm-left">
          <div
            class="arm-left-main"
            :class="leftfixed ? 'arm-left-main-fixed' : ''"
            v-if="leftdata"
          >
            <div class="alm-titile">
              <div
                class="almt-sec"
                :class="isccf ? 'almt-sec-act' : ''"
                @click="changeccf(true)"
              >
                CCF
              </div>
              <div
                class="almt-sec"
                v-if="yearindex!=3"
                :class="!isccf ? 'almt-sec-act' : ''"
                @click="changeccf(false)"
              >
                IEEE
              </div>
            </div>
            <div class="alm-body" v-if="isccf && leftdata">
              <div
                class="almb-sec"
                :class="leftindex == index ? 'almb-sec-act' : ''"
                @click="handleleftsec(key, index)"
                v-for="(i, key, index) in leftdata.rank"
                :key="key"
              >
                {{ key }}
              </div>
            </div>
            <div class="alm-body" v-if="!isccf && leftdata">
              <div
                class="almb-sec"
                :class="leftindex == index ? 'almb-sec-act' : ''"
                @click="handleleftsec(key, index)"
                v-for="(i, key, index) in leftdata.rank"
                :key="key"
              >
                {{ key }}
              </div>
            </div>
          </div>
        </div>
        <div class="arm-right" v-if="leftdata">
          <div class="armr-top">
            <div class="armrt-head">
              <span v-if="isccf">CCF Hot Key Words</span>
              <span v-if="!isccf">IEEE Category</span>
            </div>
            <div class="armrt-body">
              Welcome to CCF(China Computer Federation) hot key words by SJTU Acemap Team. We collect and analyze publications on the list of international academic periodicals and conferences recommended by CCF, and illustrate the most popular key words in the paper abstracts to reflect the current research trends in computer science. Hope you enjoy exploring the key words and topics behind. 
              <br />
              If you have any suggestions, please feel free to contact us at 
              <span @click="opennew('mailto:acemap@cs.sjtu.edu.cn')"
                >acemap@cs.sjtu.edu.cn.</span
              >
            </div>
          </div>
          <div v-if="isccf && leftdata">
            <div
              class="armr-main"
              :class="key"
              v-for="(i, key, index) in leftdata.rank"
              :key="index"
            >
              <div class="armrt-head">
                <span>{{ key }}</span>
              </div>
              <div :id="'cloudEl' + index" class="cloud-box"></div>
              <div class="armrm-body">
                <el-table
                  :data="i"
                  stripe
                  @expand-change="exchange"
                  style="width: 100%"
                >
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div
                        :class="'tablecontz' + scope.row.id"
                        class="zchart"
                      ></div>
                      <div
                        :class="'tablecontzhu' + scope.row.id"
                        class="zchart"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="keyword" label="keyword" width="180">
                  </el-table-column>
                  <el-table-column prop="ratio" label="ratio" width="180">
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index2) in tabelhead[yearindex]"
                    :key="index2"
                  >
                    <template slot="header" slot-scope="scope">
                      {{ item }}
                    </template>
                    <template slot-scope="scope">
                      <span
                        :class="
                          scope.row[item].indexOf('-') >= 0 ? 'green' : 'red'
                        "
                        >{{ scope.row[item] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div v-if="!isccf && leftdata">
            <div
              class="armr-main"
              :class="key"
              v-for="(i, key, index) in leftdata.rank"
              :key="index"
            >
              <div class="armrt-head">
                <span>{{ key }}</span>
              </div>
              <div :id="'cloudEl' + index" class="cloud-box"></div>
              <div class="armrm-body armrm-body2">
                <el-table
                  :data="i"
                  stripe
                  @expand-change="exchange"
                  style="width: 100%"
                >
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <div
                        :class="'tablecontz' + scope.row.id"
                        class="zchart"
                      ></div>
                      <div
                        :class="'tablecontzhu' + scope.row.id"
                        class="zchart"
                      ></div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="keyword" label="keyword" width="180">
                  </el-table-column>

                  <el-table-column prop="ratio" label="ratio" width="180">
                  </el-table-column>
                  <el-table-column
                    v-for="(item, index2) in tabelhead[yearindex]"
                    :key="index2"
                  >
                    <template slot="header" slot-scope="scope">
                      {{ item }}
                    </template>
                    <template slot-scope="scope">
                      <span
                        :class="
                          scope.row[item].indexOf('-') >= 0 ? 'green' : 'red'
                        "
                        >{{ scope.row[item] }}</span
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gotop-btn" v-if="leftfixed" @click="gotop">
      <img src="../../assets/images/top.png" alt="" />
    </div>
  </div>
</template>
<script>
import { getfilter, getchart } from "@/api/hotkeyword";
import { Chart } from "@antv/g2";
import * as echarts from 'echarts';
export default {
  data() {
    return {
      tableData: [],
      leftdata: [],
      rightdata: [],
      yearindex: 3,
      alldata: [],
      showlist:[],
      isccf: true,
      leftfixed: false,
      leftindex: 0,
      wordCloudData: null,
      tabelhead: [
        ["2013-2014", "2014-2015", "2015-2016", "2016-2017"],
        ["2015-2016", "2016-2017", "2017-2018", "2018-2019"],
        ["2017-2018", "2018-2019", "2019-2020", "2020-2021"],
        ["2018-2019", "2019-2020", "2020-2021", "2021-2022"],
      ],
    };
  },
  mounted() {
    document.title = 'Acemap Hot-Keywords'
    
    if (localStorage.getItem("hotkeyyear")) {
      if (localStorage.getItem("hotkeyyear") == 2021) {
        this.yearindex = 2;
      } else if (localStorage.getItem("hotkeyyear") == 2019) {
        this.yearindex = 1;
      } else if (localStorage.getItem("hotkeyyear") == 2022) {
        this.yearindex = 3;
      } else {
        this.yearindex = 0;
      }
      this.getdata(localStorage.getItem("hotkeyyear"),'ccf');
    } else {
      this.getdata(2022,'ccf');
    }
    
    let that = this;
    window.onscroll = function () {
      let scrolltop = document.documentElement.scrollTop;
      if (scrolltop >= 130) {
        that.leftfixed = true;
      } else {
        that.leftfixed = false;
      }
    };
  },
  methods: {
    opennew(url) {
      window.open(url);
    },
    getIPs (callback){
    var ip_dups = {};
    var RTCPeerConnection = window.RTCPeerConnection
      || window.mozRTCPeerConnection
      || window.webkitRTCPeerConnection;
    var useWebKit = !!window.webkitRTCPeerConnection;
    var mediaConstraints = {
      optional: [{ RtpDataChannels: true }]
    };
    // 这里就是需要的ICEServer了
    var servers = {
      iceServers: [
        { urls: "stun:stun.services.mozilla.com" },
        { urls: "stun:stun.l.google.com:19302" },
      ]
    };
    var pc = new RTCPeerConnection(servers, mediaConstraints);
    function handleCandidate(candidate) {
      var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
      var hasIp = ip_regex.exec(candidate)
      if (hasIp) {
        var ip_addr = ip_regex.exec(candidate)[1];
        if (ip_dups[ip_addr] === undefined)
          callback(ip_addr);
        ip_dups[ip_addr] = true;
      }
    }
    // 网络协商的过程
    pc.onicecandidate = function (ice) {
      if (ice.candidate) {
        handleCandidate(ice.candidate.candidate);
      }
    };
    pc.createDataChannel("");
    //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
    pc.createOffer(function (result) {
      pc.setLocalDescription(result, function () { }, function () { });
    }, function () { });
    setTimeout(function () {
      var lines = pc.localDescription.sdp.split('\n');
      lines.forEach(function (line) {
        if (line.indexOf('a=candidate:') === 0)
          handleCandidate(line);
      });
    }, 1000);
  },

    changeccf(e) {
      this.isccf = e;
      if (this.yearindex == 0) {
        
        this.getdata(2017,e?'ccf':'ieee');
        
      } else if (this.yearindex == 1) {
        
        this.getdata(2019,e?'ccf':'ieee');
        
      } else if(this.yearindex ==2){
        
        this.getdata(2021,e?'ccf':'ieee');
        
      } else {
        
        this.getdata(2022,e?'ccf':'ieee');
        
      }
      
      
    },
    drawCloud(wrapEl, data) {
      // let maskImage = new Image(); //可以根据图片形状生成有形状的词云图
      // maskImage.src= this.bgImg;
      let list = [];
      for (let i = 0; i < data.length; i++) {
        list.push({
          name: data[i].name,
          value: data[i].count,
        });
      }
      if (list.length == 0) {
        list = [{ name: "无", value: 50 }];
      }
      let myChart = echarts.init(wrapEl);
      let option = {
        tooltip: {
          show: true,
        },
        // backgroundColor:'#fff', // 画布背景色
        series: [
          {
            name: "热词",
            type: "wordCloud",
            // maskImage: maskImage, // 图片形状
            keepAspect: false,
            sizeRange: [10, 40], //画布范围，如果设置太大会出现少词（溢出屏幕）
            rotationRange: [0, 10], //数据翻转范围
            // shape: "circle",
            // drawOutOfBound: true, // 超出画布的词汇是否隐藏
            drawOutOfBound: false,
            color: "#fff",
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            // width: "100%",
            height: "100%",
            gridSize: 8,
            textPadding: 10,
            autoSize: {
              enable: true,
              minSize: 6,
            },
            textStyle: {
              normal: {
                fontFamily: "sans-serif",
                fontWeight: "bold",
                // color: "#333", // 字体颜色
                color: function () {
                  // 字体颜色
                  return (
                    "rgb(" +
                    [
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                      Math.round(Math.random() * 160),
                    ].join(",") +
                    ")"
                  );
                },
              },
              emphasis: {
                // focus: 'self',
                textStyle: {
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
            },
            data: list,
          },
        ],
      };
      // maskImage.onload = function() {
      myChart.setOption(option, true);
      // };
    },
    exchange(e, expand) {
      if(this.showlist.indexOf(e.id)>=0){
        this.showlist.splice(this.showlist.indexOf(e.id),1)
      }else{
        this.showlist.push(e.id)
      console.log(e, expand, "---184");
      if (expand.length > 0) {
        let year;
        if (this.yearindex == 0) {
          year = 2017;
        } else if (this.yearindex == 1) {
          year = 2019;
        } else if (this.yearindex == 2) {
          year = 2021;
        } else {
          year = 2022;
        }

        let cat;
        cat = e.cat;

        var formdata = new FormData();
        formdata.append("keyword", e.keyword);
        formdata.append("year", year);
        formdata.append("catergory", cat);
        let params = {
          keyword: e.keyword,
          year: year,
          category: cat,
          type: this.isccf ? "ccf" : "ieee",
        };

        getchart(params).then((res) => {
          console.log(res, "---98");
          let classnamez = "tablecontz" + e.id;
          let classnamezhu = "tablecontzhu" + e.id;
          this.$nextTick(function () {
            let container = document.getElementsByClassName(classnamez)[0];
            let containerzhu = document.getElementsByClassName(classnamezhu)[0];
            console.log(container, "---213");
            this.initzchart(res.data.Ratio_paperNum, container);
            let zhudata = [];
            for (let i = 0; i < res.data.Trend.length; i++) {
              zhudata.push({
                name: res.data.Trend[i].name,
                trend: +res.data.Trend[i].Trend.substring(
                  0,
                  res.data.Trend[i].Trend.length - 1
                ),
              });
            }
            this.initzhuchart(zhudata, containerzhu);
          });
        });
      }
      }
      
    },
    initzchart(data, container) {
      const chart = new Chart({
        container: container,
        autoFit: true,
        height: 500,
      });

      chart.data(data);
      chart.scale({
        date: {
          alias: "日期",
          type: "time",
        },
        Ratio: {
          alias: "ratio(%)",
          min: 0,
          sync: true, // 将 pv 字段数值同 time 字段数值进行同步
          nice: true,
        },
        Paper_Num: {
          alias: "papers",
          min: 0,
          sync: true, // 将 pv 字段数值同 time 字段数值进行同步
          nice: true,
        },
      });

      chart.axis("ratio", {
        grid: null,
        title: {},
      });
      chart.axis("paper number", {
        title: {},
      });

      chart.tooltip({
        showCrosshairs: true,
        shared: true,
      });

      chart.line().position("name*Ratio").color("#4FAAEB");
      chart.line().position("name*Paper_Num").color("#9AD681").shape("dash");
      chart.render();
    },
    initzhuchart(data, container) {
      const chart = new Chart({
        container: container,
        autoFit: true,
        height: 500,
      });
      console.log(data, "---377");
      chart.data(data);

      chart.scale("trend", {
        alias: "trend(%)",
        nice: true,
      });
      chart.axis("trend", {
        label: null,
        title: {
          offset: 30,
        },
      });
      chart.tooltip({
        showMarkers: false,
        formatter: function (val) {
          console.log(val, "---451");
          var tipText = "";
          tipText +=
            val[0].name +
            " : " +
            "<br/>" +
            val[0].seriesName +
            " : " +
            val[0].value +
            "<br/>" +
            val[1].seriesName +
            " : " +
            val[1].value +
            "%<br/>";
          return tipText;
        },
      });
      chart.interaction("active-region");
      chart.legend(false);
      chart.interval().position("name*trend");

      chart.render();
    },
    changeyear(e) {
      this.yearindex = e;
      // this.leftdata = this.alldata[e];
      this.isccf = true;
      if (e == 0) {
        localStorage.setItem("hotkeyyear", 2017);
        window.location.reload();
        // this.getdata(2017)
      } else if (e == 1) {
        localStorage.setItem("hotkeyyear", 2019);
        window.location.reload();
        // this.getdata(2019)
      } else if(e ==2){
        localStorage.setItem("hotkeyyear", 2021);
        window.location.reload();
        //  this.getdata(2021)
      } else {
        localStorage.setItem("hotkeyyear", 2022);
        window.location.reload();
        //  this.getdata(2021)
      }
    },
    handleleftsec(e, index) {
      this.leftindex = index;
      let dom = document.getElementsByClassName(e)[0].offsetTop;
      window.scrollTo(0, dom + 141);
    },
    gotop() {
      window.scrollTo(0, 0);
    },
    getdata(e,type) {
      let params = {
        year:e,
        type:type
      }
      getfilter(params).then((res) => {
        // this.alldata = res.data;
        this.leftdata = res.data.data;
        let cloudlist = [];
        this.showlist = [];
        if (this.isccf) {
          cloudlist = this.leftdata.word_cloud;
        } else {
          cloudlist = this.leftdata.word_cloud;
        }

        this.$nextTick(function () {
          for (let i = 0; i < cloudlist.length; i++) {
            let str = "cloudEl" + i;
            let el = document.getElementById(str);
            console.log(cloudlist[i], "---477");
            this.drawCloud(el, cloudlist[i]);
          }
        });
        // this.rightdata = res.data[2].
      });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.archive-head {
  width: 100%;
  background-color: #0275d8;
  color: white;
  font-size: 16px;
  height: 50px;
  padding: 10px 15px;
  img {
    width: 100px;
  }
}
.archive-main {
  background: #f0f2f5;
  padding: 20px 15px;
  min-height: 100vh;
}
.arm-head {
  width: 100%;
  padding: 0 20px;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  color: #0275d8;
  font-weight: bold;
  margin-bottom: 20px;
  img {
    vertical-align: middle;
  }
}
.almb-sec-act {
  color: #0275d8;
  background-color: #e5f1fb;
  border-left: #0275d8 3px solid;
}
.arm-head-btn {
  display: inline-block;
  cursor: pointer;
  width: 52px;
  height: 30px;
  line-height: 30px;
  margin-left: 5px;
  border-radius: 5px;
  background-color: #f0f2f5;
  text-align: center;
  color: #0275d8;
}
.arm-head-btn-act {
  background-color: #337ab7;
  color: #fff;
}
.arm-body {
  width: 100%;
  display: flex;
  position: relative;
}
.arm-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 250px;
}
.arm-left-main {
  width: 250px;
  background-color: #fff;
  border-radius: 5px;
}
.arm-left-main-fixed {
  position: fixed;
  top: 0;
  left: 15px;
}
.arm-left-main-fixed .alm-body {
  height: calc(100vh - 64px);
  overflow: hidden;
  overflow-y: auto;
}
.arm-right {
  flex: 1;
  margin-left: 270px;
}
.alm-titile {
  width: 100%;
  display: flex;
  font-size: 15px;
}
.green {
  color: #8fbc8f;
}
.red {
  color: #db7093;
}
.almt-sec {
  flex: 1;
  text-align: center;
  cursor: pointer;
  height: 42px;
  line-height: 42px;
  font-weight: bold;
}
.alm-body {
  width: 100%;
}
.almb-sec {
  width: 100%;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
}
.almb-sec:hover {
  color: #337ab7;
}
.armr-top {
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
}
.armrt-head {
  padding: 15px;
  border-bottom: #f0f0f0 1px solid;
  font-size: 15px;
  span {
    display: inline-block;
    border-left: #0275d8 3px solid;
    padding-left: 10px;
    font-weight: bold;
    line-height: 15px;
  }
}
.armrt-body {
  padding: 15px;
  font-size: 14px;
  span {
    color: #46b8da;
    cursor: pointer;
  }
}
.armr-main {
  width: 100%;
  margin-top: 20px;
  border-radius: 5px;
  background-color: #fff;
}
.almt-sec-act {
  color: #337ab7;
}
.gotop-btn {
  position: fixed;
  bottom: 50px;
  right: 100px;
  cursor: pointer;
}
.zchart {
  height: 200px;
  width: 350px;
  margin-right: 30px;
  display: inline-block;
}
.cloud-box {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotkeywords/index.vue